import { css } from "@emotion/react";
import colors from "assets/css/colors";
import fontSize from "assets/css/fontSize";
import fontWeight from "assets/css/fontWeight";

export const rowCss = css`
  column-gap: 24px;
`;

export const wrapperCss = css`
  width: 350px;
`;

export const inputCss = css`
  height: 40px;
`;

export const mainContainerCss = css`
  gap: 150px;
  align-items: baseline;
`;

export const tabsContentCss = css`
  gap: 150px;
  min-height: 547px;
  width: 100%;
`;

export const leftContainerCss = css`
  flex: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 28px;
  padding-top: 16px;
`;

export const rightContainerCss = css`
  flex: 1 auto;
  display: flex;
  flex-direction: column;
  gap: 28px;
  padding-top: 16px;
`;

export const textAreaContainerCss = css`
  display: flex;
  flex-direction: column;
  gap: 4px 10px;
`;

export const textAreaCss = css`
  height: 200px;
  width: 350px;
  padding: 10px 32px 10px 12px;
  box-sizing: border-box;
  resize: none;
  border: 1px solid ${colors.strokeGrey};
  border-radius: 4px;

  &:focus {
    outline: none;
    border: 1px solid ${colors.mainBlue};
  }

  &:disabled {
    background-color: ${colors.bgGrey};
    border: 1px solid ${colors.strokeGrey};
    color: variables.$grey;
  }

  &::placeholder {
    color: ${colors.grey};
    text-transform: capitalize;
  }
`;

export const alignedTextAreaCss = [
  textAreaCss,
  css`
    height: 150px;
  `,
];

export const integrationsItemCss = [
  mainContainerCss,
  css`
    padding-bottom: 32px;
    border-bottom: 1px solid ${colors.strokeGrey};
    margin-bottom: 32px;
  `,
];

export const smallerTextArea = [
  textAreaCss,
  css`
    height: 100px;
  `,
];

export const containerCss = css`
  margin-right: 8px;
`;

export const saveButtonCss = css`
  margin-top: 40px;
`;

export const boostrTextAreaCss = [
  textAreaCss,
  css`
    height: 100px;
  `,
];

export const subHeading = css`
  font-size: ${fontSize.lg};
  font-weight: ${fontWeight.bold};
  color: ${colors.textBlack};
  text-transform: capitalize;
`;

export const checkboxCss = css`
  font-size: ${fontSize.lg};
  font-weight: ${fontWeight.bold};
  color: ${colors.textBlack};
  height: 20px;
  width: 20px;
  margin-right: 10px;
`;

export const iconCss = css`
  color: ${colors.grey};
`;

export const integrationsCss = css`
  flex: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
